<template>
  <div class="ebook-question bg-color-light">
    <div class="
          ebook-question__head
          d-flex
          align-items-center
          justify-content-md-between
          full-width
        ">
      <a href="javascript:;" class="ebook-question__back secondary-color-txt display-flex-center" @click="backReadBook">
        <span class="icon-arrow-left secondary-color-txt"><span class="path1 secondary-color-txt"></span><span
            class="path2 secondary-color-txt"></span></span>
        <p class="margin-0 only-pc">Quay lại</p>
      </a>
      <h2 class="
            ebook-question__title
            secondary-color-txt
            font-size-16
            display-flex-center
            margin-0
          ">
        <span v-for="(item, index) of catTitleQuestion" :key="index" class="display-flex-center">
          {{ item.title }}
          <span v-if="item.title" class="mr-1">: </span>
          {{ item.name }}
          <span v-show="index < catTitleQuestion.length - 1" class="icon-arrow-right secondary-color-txt"><span
              class="path1"></span><span class="path2"></span></span>
        </span>
      </h2>
      <span class="div-empty d-sm-none d-lg-block" />
    </div>
    <div class="ebook-question__body custom-scroll">
      <div class="container">
        <div class="book-viewer__question">
          <div name="list" class="question-group" v-if="
            questionCurr &&
            questionCurr.type &&
            questionCurr.type === typeGroup
          ">
            <PreviewQuestion :dataSource="questionCurr" :questions="[questionCurr]" :location="0" :preview="true"
              :questionsData="questionCurr" @writedAnswer="writedAnswer" @setCorrectAnswer="setCorrectAnswer" />
            <div class="questions-child" v-if="questionCurr.listQuestionChild">
              <transition-group nam="list">
                <div class="questions-child__item" v-for="(child, pos) of questionCurr.listQuestionChild"
                  :key="`child_${pos}`">
                  <PreviewQuestion :dataSource="child" :location="pos" :parentIndex="0" :isQuestionChild="true"
                    :preview="true" :questionsData="questionCurr" @writedAnswer="writedAnswer"
                    @setCorrectAnswer="setCorrectAnswer" />
                </div>
              </transition-group>
            </div>
          </div>
          <transition name="list" class="question-single" v-else-if="questionCurr">
            <PreviewQuestion :dataSource="questionCurr" :location="0" :preview="true" @writedAnswer="writedAnswer"
              @setCorrectAnswer="setCorrectAnswer" />
          </transition>
        </div>
        <ExerciseGuide ref="ExerciseGuide" v-if="questionCurr" :question="questionCurr"
          :handleShowGuide="showGuideContent" :isShowGuide="isShowGuide" v-show="answersCorrect" />
        <div class="overlay-question" v-if="valVituralKeyboard.location > -1 && screenWidth > 991"
          @click="resetValKeyboard"></div>
        <VituralKeyboard v-if="
          valVituralKeyboard.location > -1 &&
          screenWidth > 991 &&
          ebooksDetail.classId === idClass1 &&
          ebooksDetail.subjectId === idMathSubject
        " :class="{
  'over-height':
    valVituralKeyboard && valVituralKeyboard.isOverHaflScreen,
}" :style="`top: ${valVituralKeyboard.top}px; left: ${valVituralKeyboard.left}px`" />
      </div>
    </div>
    <div class="ebook-question__footer color_bg_gray_light full-width">
      <div class="ebook-question__left" />
      <!--  display-flex-center justify-content-between -->
      <!-- <span class="div-empty" /> -->
      <div class="ebook-question__center text-center">
        <div v-if="
          questionBookWorking.listQuestionGroupPage &&
          questionBookWorking.listQuestionGroupPage.length > 1
        " class="ebook-question__slider justify-content-center">
          <!-- display-flex-center -->
          <div slot="button-prev" @click="handleDirectQuestionGroup(indexQuestionCurr - 1)"
            class="ebook-question__prev cursor-pointer position-rel">
            <i class="icon-prev primary-color font-size-20 cursor-pointer"></i>
          </div>
          <div class="ebook-question__slider__wrap">
            <swiper id="swiper_question" ref="swiper_question" class="swiper" :options="optionSlider">
              <swiperSlide v-for="(
                    item, index
                  ) of questionBookWorking.listQuestionGroupPage" :key="index">
                <a :class="{
                  curr:
                    index === indexQuestionCurr ||
                    (item.isWorked && !item.isNoAnswer),
                  success:
                    item.type !== typeQuestionDownAnswer &&
                    ((item.answerStatus !== null &&
                      item.answerStatus === 'success') ||
                      (item.statusWorked && !item.workedFail) ||
                      (item.isWorked && item.isTrue)),
                  error:
                    item.type !== typeQuestionDownAnswer &&
                    !item.isNoAnswer &&
                    ((item.answerStatus !== null &&
                      item.answerStatus === 'error') ||
                      (item.statusWorked && item.workedFail === 'error') ||
                      (item.isWorked && !item.isTrue)),
                }" @click="handleDirectQuestionGroup(index)">
                  {{ item.title }}
                </a>
              </swiperSlide>
            </swiper>
          </div>
          <div slot="button-next" @click="handleDirectQuestionGroup(indexQuestionCurr + 1)"
            class="ebook-question__next cursor-pointer position-rel">
            <i class="icon-next primary-color font-size-20 cursor-pointer"></i>
          </div>
        </div>
      </div>
      <div class="ebook-question__btns">
        <button v-if="questionCurr.isWorked" type="button" class="
              btn btn-main
              border-rd-20
              font-size-16
              line-height-1
              ebook-question__submit
            " @click="resetQuestions()">
          Làm lại
        </button>
        <button v-if="!questionCurr.isWorked" type="button" class="
              btn btn-main
              border-rd-20
              font-size-16
              line-height-1
              ebook-question__submit
            " @click="doneExercise">
          {{
            questionCurr.type === typeQuestionDownAnswer
            ? "Lưu đáp án"
            : "Kiểm tra"
          }}
        </button>
      </div>
    </div>
    <!-- <audio
      v-if="actionPlayQuestionTrue"
      :src="correct"
      id="question_true"
      autoplay
    />
    <audio
      v-if="actionPlayQuestionFalse"
      :src="incorrect"
      id="question_false"
      autoplay
    /> -->
    <audio :src="correct" id="question_true" />
    <audio :src="incorrect" id="question_false" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { STORE_KEY } from "./../../_store/constants";
import {
  STORE_KEY as STORE_KEY_QUESTION,
  TYPE_GROUP,
  TYPE_FILL_BLANK,
  TYPE_SELECT,
  TYPE_DOWN_ANSWER,
} from "@/modules/question/preview-question/_store/constants";
import { ID_CLASS_1, ID_MATH_SUBJECT } from "@/store/common/constants";
import { getQuestionDetail } from "@/modules/exercises/_api";
import { getAuth } from "@/utils/jwt";
import {
  saveUserWorkQuestion,
  resetResultWorkQuestion,
} from "@/modules/exercises/_api";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { EMAIL_PUBLIC } from "@/store/auth/constants";
import { callTimeDiff } from "@/helpers/functions";
import { setContentMediaEditorShow } from "@/modules/question/preview-question/_store/helperQuestionContent";
const correct = require("@/assets/audio/correct.mp3");
const incorrect = require("@/assets/audio/incorrect.mp3");

export default {
  name: "EbookQuestion",
  props: {
    cats: Array,
    questions: Array, // All question in page for questionGroup
  },
  components: {
    swiper,
    swiperSlide,
    PreviewQuestion: () =>
      import("@/modules/question/preview-question/PreviewQuestion.vue"),
    VituralKeyboard: () =>
      import("@/modules/question/preview-question/VituralKeyboard.vue"),
    ExerciseGuide: () =>
      import("@/modules/exercises/_components/ExerciseGuide.vue"),
  },
  data() {
    return {
      correct,
      incorrect,
      actionPlayQuestionTrue: false,
      actionPlayQuestionFalse: false,
      idMathSubject: ID_MATH_SUBJECT,
      correctAnswersOfQuestions: [],
      typeGroup: TYPE_GROUP,
      catTitleQuestion: [],
      authInfo: {},
      emailPublic: EMAIL_PUBLIC,
      idClass1: ID_CLASS_1,
      optionSlider: {
        slidesPerView: 8,
        spaceBetween: 10,
        slidesPerGroup: 3,
        loop: false,
        loopFillGroupWithBlank: true,
        breakpoints: {
          1199: { slidesPerView: 6, slidesPerGroup: 3 },
          991: { slidesPerView: 6, slidesPerGroup: 2 },
          767: { slidesPerView: 3, slidesPerGroup: 2 },
          575: { slidesPerView: 2, slidesPerGroup: 1 },
        },
        navigation: {
          nextEl: `.ebook-question__next`,
          prevEl: `.ebook-question__prev`,
        },
      },
      startTimeQuestion: 0,
      indexQuestionCurr: 0,
      questionCurr: {},
      showGuideContent: false,
      typeQuestionDownAnswer: TYPE_DOWN_ANSWER,
      isFetchQuestionWorked: false,
      isShowGuide: false,
      answersCorrect: false,
    };
  },
  computed: {
    ...mapState(STORE_KEY, ["questionBookWorking", "ebooksDetail"]),
    ...mapState(STORE_KEY_QUESTION, ["valVituralKeyboard"]),
    ...mapState("auth", ["loginPopupData"]),

    screenWidth() {
      return window.innerWidth;
    },
    swiper() {
      return this.$refs.swiper_question.swiper;
    },
  },
  watch: {
    questionBookWorking(newVal) {
      newVal && this.getInfoQuestion();
    },
    loginPopupData(newVal) {
      if (newVal && Object.keys(newVal).length) {
        this.authInfo = newVal;
      }
    },
    questionCurr(newVal) {
      if (newVal.isWorked) this.answersCorrect = newVal.isWorked;
      else this.answersCorrect = false;
    },
  },
  created() {
    this.authInfo = getAuth();
    // Return book viewer
    // !this.questionId && this.backReadBook()
    window.addEventListener('keyup', this.onKeyup)
  },
  mounted() {
    // (!this.questionBookWorking || Object.keys(this.questionBookWorking).length === 0) && this.fetchDetailQuestion()
    this.cats && this.getInfoQuestion();
    this.startTimeQuestion = new Date();
  },
  beforeDestroy() {
    this.acSetEbookQuestionWork({});
    this.showGuideContent = false;
  },
  destroyed() {
    window.removeEventListener('keyup', this.onKeyup)
  },
  methods: {
    // Actions common for report error question
    ...mapActions("common", [
      "setLoading",
      "actionSetQuestionId",
      "actionSetBookIndexId",
      "setActionCheckQuestion",
    ]),
    ...mapActions(STORE_KEY, ["acSetEbookQuestionWork"]),
    ...mapActions(STORE_KEY_QUESTION, [
      "setVituralKeyVal",
      "setQuestionData4CheckAnswer",
    ]),

    async getInfoQuestion() {
      if (
        this.questionBookWorking &&
        this.questionBookWorking.bookIndexId &&
        this.cats
      ) {
        this.showGuideContent = false;
        const catCurr = await this.cats.find(
          (cat) => cat.bookIndexId === this.questionBookWorking.bookIndexId
        );
        this.catTitleQuestion = [catCurr];
        // Actions common for report error question
        this.actionSetQuestionId(catCurr.questionId);
        this.actionSetBookIndexId(catCurr.bookIndexId);
        if (catCurr && catCurr.parentId) {
          const catParent = await this.cats.find(
            (cat) => cat.bookIndexId === catCurr.parentId
          );
          // this.catTitleQuestion = [ catParent, catCurr ]
          this.catTitleQuestion = [catParent];
        }
        // set question curr display
        this.handleSetQuestionDisplay();
      }
    },

    // set question curr display
    handleSetQuestionDisplay() {
      const questionData =
        this.questionBookWorking.listQuestionGroupPage[this.indexQuestionCurr];
      if (questionData.isWorked && !this.isFetchQuestionWorked) {
        this.isFetchQuestionWorked = true;
        this.fetchDetailQuestion(questionData);
      } else {
        const typeQuestion =
          questionData.type === TYPE_GROUP ? "group" : "single";
        const questionReplaceContent = setContentMediaEditorShow(
          { ...questionData },
          typeQuestion
        );
        this.questionCurr = questionReplaceContent;
        // // listQuestionGroupPage: Array question group in book page
        // this.questionCurr = this.questionBookWorking.listQuestionGroupPage[this.indexQuestionCurr]
      }
      // console.log('Question detail: ', questionData)
    },

    async fetchDetailQuestion(questionData = null) {
      const question = await getQuestionDetail(
        questionData ? questionData.questionId : this.questionCurr.questionId
      );
      if (question.data) {
        const typeQuestion =
          question.data.type === TYPE_GROUP ? "group" : "single";
        const questionReplaceContent = setContentMediaEditorShow(
          { ...question.data },
          typeQuestion
        );
        this.questionCurr = await questionReplaceContent;
        this.questionBookWorking.listQuestionGroupPage[this.indexQuestionCurr] =
          questionReplaceContent;
        this.acSetEbookQuestionWork({ ...this.questionBookWorking });
      }
      // const question = await getQuestionDetail(this.questionId)
      // question.data && this.acSetEbookQuestionWork(question.data)
    },

    backReadBook() {
      this.acSetEbookQuestionWork({});
      this.$router.replace({ query: null });
    },

    resetValKeyboard() {
      this.valVituralKeyboard && this.setVituralKeyVal({});
    },

    writedAnswer(val) {
      // console.log('Write answer', val);
      let self = this;
      let correctAnswer = self.setValDataAnswerSave(val);
      let dataCorrect = {
        questionId: val.question.questionId,
        answers: correctAnswer.answers,
      };

      // console.log('set done: ', dataCorrect);

      if (self.correctAnswersOfQuestions.length === 0) {
        self.correctAnswersOfQuestions = [dataCorrect];
        return;
      }

      let correctPosition = self.correctAnswersOfQuestions.findIndex(
        (correct) => correct.questionId === val.question.questionId
      );
      if (correctPosition > -1) {
        self.correctAnswersOfQuestions[correctPosition] = dataCorrect;
      } else {
        self.correctAnswersOfQuestions.push(dataCorrect);
      }
    },

    setValDataAnswerSave(data) {
      let self = this;
      var result = { answers: [], question: data.question };
      // let valFillBlank = [];

      data.answers.map((ans, index) => {
        let answerPosition = ans.position;
        let pacticeIndex = index;
        let datapractice = {
          questionId: data.question.questionId,
          answerId: data.question.answers[answerPosition].answerId,
          bookId: data.question.bookId,
          pageNo: data.question.pageNo,
          answerPosition: ans.position,
          answerContent: [],
        };

        if (
          data.question.type === TYPE_FILL_BLANK ||
          data.question.type === TYPE_SELECT
        ) {
          let dataVal = [];
          let answerParent = data.question.answers.filter((an) => !an.position);
          if (answerParent.length > 0) {
            data.answers.map((an) => {
              if (an.position === ans.position) {
                dataVal[an.select_index] = an.value;
              }
            });
            datapractice.answerContent = JSON.stringify(dataVal);
            datapractice.answerId = answerParent[ans.position].answerId;
          }
        } else {
          datapractice.answerContent = ans.value;
        }

        if (self.correctAnswersOfQuestions.length > 0) {
          let pacticeIndexInit = self.correctAnswersOfQuestions.findIndex(
            (prac) => prac.questionId === data.question.questionId
          );
          if (pacticeIndexInit > -1) {
            // Set default
            result.answers = [
              ...self.correctAnswersOfQuestions[pacticeIndexInit].answers,
            ];

            let answerPracticeIndex = self.correctAnswersOfQuestions[
              pacticeIndexInit
            ].answers.findIndex(
              (anPrac) =>
                anPrac.answerId ===
                data.question.answers[answerPosition].answerId
            );

            if (answerPracticeIndex > -1) {
              pacticeIndex = answerPracticeIndex;
              datapractice.answerPosition =
                self.correctAnswersOfQuestions[pacticeIndexInit].answers[
                  answerPracticeIndex
                ].answerPosition;
              result.answers[answerPracticeIndex] = {
                ...self.correctAnswersOfQuestions[pacticeIndexInit].answers[
                answerPracticeIndex
                ],
                ...datapractice,
              };
            } else {
              result.answers.push(datapractice);
            }
          } else {
            result.answers.push(datapractice);
          }
        } else {
          result.answers.push(datapractice);
        }
      });
      return result;
    },

    async resetQuestions() {
      this.isShowGuide = false;
      this.$refs.ExerciseGuide.showGuideContent = false;
      this.correctAnswersOfQuestions = [];
      this.resetValKeyboard();
      if (!this.questionCurr.questionId) {
        return;
      }
      if (self.authInfo && self.authInfo.email === EMAIL_PUBLIC) {
        this.fetchDetailQuestion();
      } else {
        this.setLoading(true);
        resetResultWorkQuestion(this.questionCurr.questionId)
          .then((res) => {
            if (res && !res.errors) {
              this.fetchDetailQuestion();
              this.startTimeQuestion = new Date();
            }
          })
          .finally(() => this.setLoading(false));
      }
    },

    doneExercise() {
      /* ModifiBy: anhdd(13/12/2022)
       */
      let self = this;
      // console.log("Question answer: ", self.questionCurr);
      // self.resetValKeyboard();
      if (self.questionCurr.type !== TYPE_DOWN_ANSWER) {
        // console.log('Question answer: ', self.questionCurr)
        if (self.correctAnswersOfQuestions.length === 0) {
          this.$toast.error("Vui lòng chọn câu trả lời");
          return;
        }

        if (
          self.indexQuestionCurr === -1 ||
          self.correctAnswersOfQuestions.length === 0
        ) {
          return;
        }
        self.setLoading(true);
        let questionGroup = self.questionCurr.type === TYPE_GROUP;
        self.setQuestionData4CheckAnswer({
          ...self.questionCurr,
          isGroup: questionGroup,
        });
        self.setActionCheckQuestion(true);
      } else {
        self.setLoading(true);
      }
      // console.log('Check done question: ', self.questionCurr, self.correctAnswersOfQuestions);

      self.questionCurr.parentId = self.questionCurr.parentId
        ? self.questionCurr.parentId
        : 0;

      // console.log("Payload requestion done question", self.questionCurr);
      if (self.authInfo && self.authInfo.email !== EMAIL_PUBLIC) {
        let timeCal = callTimeDiff(this.startTimeQuestion);
        setTimeout(() => {
          saveUserWorkQuestion(self.questionCurr, timeCal.minute)
            .then(async () => {
              await self.fetchDetailQuestion();
              // self.showGuideContent = true;
              self.answersCorrect = true;
            })
            .finally(() => self.setLoading(false));
        }, 5);
      } else {
        self.setLoading(false);
      }
      // if (self.questionCurr.type !== TYPE_DOWN_ANSWER) {
      //   console.log("self.questionCurr.isTrue", self.questionCurr.isTrue);
      //   if (self.questionCurr.isTrue) {
      //     self.actionPlayQuestionTrue = true;
      //     setTimeout(() => {
      //       document.getElementById("question_true").play();
      //     }, 5);
      //   } else {
      //     self.actionPlayQuestionFalse = true;
      //     setTimeout(() => {
      //       document.getElementById("question_false").play();
      //     }, 5);
      //   }
      // } else {
      //   self.actionPlayQuestionTrue = true;
      //   setTimeout(() => {
      //     document.getElementById("question_true").play();
      //   }, 5);
      // }

      if (self.answersCorrect) self.isShowGuide = true;
      else self.isShowGuide = false;
      if (self.questionCurr.type == TYPE_DOWN_ANSWER) {
        self.isShowGuide = true;
        self.answersCorrect = true;
      }
    },
    onKeyup(e) {
      e.keyCode === 37 && this.handleDirectQuestionGroup(this.indexQuestionCurr - 1)
      e.keyCode === 39 && this.handleDirectQuestionGroup(this.indexQuestionCurr + 1)
    },
    handleDirectQuestionGroup(index) {
      // this.answersCorrect = false;
      if (
        index >= this.questionBookWorking.listQuestionGroupPage.length ||
        index < 0
      ) {
        return;
      }
      if (this.indexQuestionCurr !== index) {
        this.indexQuestionCurr = index;
        this.handleSetQuestionDisplay();
        this.correctAnswersOfQuestions = [];
        this.handleNextPrevSlide(index + 1);
      }
      // this.acSetEbookQuestionWork(this.)
    },

    handleNextPrevSlide(position) {
      if (this.screenWidth < 768) {
        return;
      }
      const spaceAction = 2;
      const slidePerGroup = this.screenWidth > 991 ? 3 : 2;
      let slidesPerView = 8;

      if (this.screenWidth > 991 && this.screenWidth < 1200) {
        slidesPerView = 6;
      } else if (this.screenWidth > 767 && this.screenWidth < 992) {
        slidesPerView = 4;
      }
      const belowLimit = slidePerGroup * (this.swiper.snapIndex + 1);
      const aboveLimit = belowLimit - spaceAction + slidesPerView;
      if (position < belowLimit) {
        this.swiper.slidePrev(1000);
      } else if (position >= aboveLimit - spaceAction) {
        this.swiper.slideNext(1000);
      }
    },

    setCorrectAnswer(val) {
      let self = this;
      self.answersCorrect = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.ebook-question {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;

  &__head,
  &__footer {
    position: fixed;
    left: 0;
    padding: 0 20px;
  }

  &__head {
    top: 0;
    height: 50px;
    box-shadow: 0 0 7px rgba($color_dark, 0.2);
    -webkit-box-shadow: 0 0 7px rgba($color_dark, 0.2);
  }

  &__footer {
    bottom: 0;
    height: 60px;
    padding: 13px 20px;
  }

  &__body {
    height: calc(100vh - 110px);
    margin-top: 50px;
    overflow: auto;
    padding: 30px 0 10px;
  }

  &__back {

    [class^="icon-"],
    [class*=" icon-"] {
      margin-right: 5px;
    }
  }

  &__title {

    [class^="icon-"],
    [class*=" icon-"] {
      margin: 0 6px;
    }
  }

  &__submit {
    padding: 0 30px;
  }

  &__prev,
  &__next {
    width: 32px;
    line-height: 2.4;
  }

  &__slider {
    @extend .position-rel;
    // float: left;
    // width: calc(100% - 120px);
    // width: 55%;
    // max
    // max-width: 85%;
    max-width: 660px;
    display: flex;
    margin: 0 auto;

    >* {
      padding: 0 6px;
    }

    &__wrap {
      @media screen and (max-width: 992px) {
        width: calc(100% - 70px);
      }
    }

    .swiper-slide,
    .form-qes {
      min-width: 65px;
      text-align: center;

      a {
        padding: 0 6px;
        @extend .position-rel;
        @extend .display-block;
        @extend .primary-color-txt;
        @extend .font-sanpro-semibold;
        line-height: 2;
        cursor: pointer;

        &:after {
          content: "";
          @extend .bg-transparent;
          height: 2.5px;
          @extend .full-width;
          position: absolute;
          bottom: 0;
          left: 0;
          border-radius: 3px 3px 0 0;
        }

        &.curr {
          &:after {
            @extend .primary-bg-color;
          }
        }

        &.success {
          &:after {
            @extend .secondary-bg-color;
          }
        }

        &.error {
          &:after {
            @extend .four-bg-color;
          }
        }
      }

      @media screen and (max-width: 575px) {
        max-width: 50px;
        min-width: 30px;
        padding-left: 0;
      }
    }
  }

  &__left {
    float: left;
    width: 110px;
    height: 1px;
  }

  &__center {
    float: left;
    width: calc(100% - 260px);
  }

  &__btns {
    float: right;
  }

  @media screen and (max-width: 1199px) {
    // &__slider {
    //   width: calc(100% - 120px);
    // }
  }

  @media screen and (max-width: 767px) {
    &__head {
      padding: 5px 15px;
      // height: auto;
    }

    &__body {
      margin-top: 65px;
      padding-bottom: 80px;
    }

    &__back {
      margin-right: 15px;
    }

    &__submit {
      padding: 0 20px;
    }
  }

  @media screen and (max-width: 575px) {
    &__left {
      width: 0;
    }

    &__center {
      width: calc(100% - 90px);
    }
  }
}

#swiper_question {
  max-width: 640px;
}
</style>
